import {
    ChangeDetectionStrategy,
    Component,
    Input,
    OnInit,
} from '@angular/core';
import { map } from 'rxjs/operators';
import { ChoiceListService } from 'src/app/acl-data/choice-list/choice-list.service';
import { Document } from 'src/app/acl-data/document/document.dto';

export enum DocumentClasses {
    Fixed_Term_Contract = 'FixedTermContract',
    Indefinete_Contract = 'Contract',
    Transaction_Contract = 'TransactionContract',
}

@Component({
    selector: 'app-document-view-properties',
    templateUrl: './document-view-properties.component.html',
    styleUrls: ['./document-view-properties.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DocumentViewPropertiesComponent implements OnInit {
    @Input() doc: Document;
    @Input() objectStore: string;

    DocumentClasses = DocumentClasses;

    selectedItems = [];

    territories$ = this.choiceListService
        .getByID(this.objectStore, 'allTerritories', 'allTerritories')
        .pipe(
            map(v => {
                const result = Object.keys(v.value).reduce(
                    (acc, row) => [...acc, { id: row, itemName: v.value[row] }],
                    []
                );
                return result;
            })
        );

    territoriesSelected$ = this.territories$.pipe(
        map(v =>
            v.filter(
                row =>
                    this.doc.propertiesObj.ContractTerritories.indexOf(
                        Number(row.id)
                    ) >= 0
            )
        )
    );
    constructor(private choiceListService: ChoiceListService) {}

    ngOnInit(): void {}
}
